(ns ui.view.transaction-process.cards.placeholder
  (:require
   [common.localization :refer [tr]]
   [ui.view.transaction-process.cards.card-header :as card-header]))

(defn view
  [{:keys [card]}]
  [:div {:class "bg-white rounded-lg border border-gray-200 p-6"}
   [card-header/view {:card card}]
   [:div {:class "flex items-center justify-center h-20 text-gray-400 text-sm m-0 italic"}
    (tr :transaction-process/coming-soon)]])
